import { IdCodeLibelle } from '../../id-code-libelle.abstract.model';

export class TypeControle extends IdCodeLibelle {}
